import React from 'react';
import styled from 'styled-components';
import UserCompanyRegistrationForm from '../components/UserCompanyRegistrationForm';
import { Breadcrumbs, Link, Typography } from '@mui/material';

export default function UserCompanyRegistration() {
  return (
    <Wrapper className='container'>
      <Breadcrumbs aria-label="breadcrumb" className='mb-5 mt-2 pageBreadCrumbs'>
        <Link underline="hover" color="inherit" href="/user-companies">
          Companies
        </Link>
        <Typography sx={{ color: 'text.primary' }}> Register Company </Typography>
      </Breadcrumbs>

      <h2 className='pageTitle after_title_line'> <span> Register your company </span> </h2>
      <p className='statusBox'>
        Register your company to get started. Approval is required before
        adding products.
      </p>

      <UserCompanyRegistrationForm />
    </Wrapper>
  )
}

const Wrapper = styled.div`
.statusBox{
    background: var(--bg-color);
    border-left: 6px solid var(--secondary-color);
    padding: 4px 10px;
    color: var(--primary-color);
    margin-bottom: 20px;
}
.pageBreadCrumbs{
    a:hover {
        text-decoration: none;
        color: var(--secondary-color);
    }
}
`
